/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useUpdateEffect } from 'react-use';
import { INPUT_PROPERTIES_SERIAL } from '../../common/consts';
import RobotRegisterCard from './RobotRegisterCard';
import NewModal from '../NewModal';

const RobotUpdateModal = ({
  open,
  items,
  groups: pGroups,
  onUpdate,
  onCancel,
}) => {
  const [list, setList] = useState(items);
  const [groups, setGroups] = useState(pGroups || []);

  useEffect(() => {
    if (open) {
      setList([...items]);
    }
  }, [items]);

  useEffect(() => {
    if (open) {
      setGroups([...pGroups]);
    }
  }, [pGroups]);

  const checkValidation = (item, value) => {
    const e = { [item]: '' };
    if (item === 'serial') {
      if (!INPUT_PROPERTIES_SERIAL.pattern.test(value) || value.length < 8) {
        e[item] = '유효하지 않은 시리얼 번호 형식입니다.';
      }
    } else if (item === 'alias') {
      if (
        value.search(/[\xC0-\xFF\\!@#$%^&*()=+`₩~{}|[\];:'"<>?//]/) > -1 ||
        value.length > 15
      ) {
        e[item] =
          '별칭은 한글, 영문, 숫자, .,-_ 문자열만 15자 이하로 입력 가능합니다.';
      }
    }
    return e;
  };

  const onItemChange = (e, i) => {
    const { value: v, name: n } = e.target;
    const changeItem = n.split('-');
    const prop = changeItem[0];
    let newValue;
    let newError = { ...list[i].error };
    const newList = [...list];
    if (prop === 'groups') {
      if (changeItem[1] === 'add') {
        setGroups([...groups, v]);
      }
      if (changeItem[1] === 'select') {
        const selIdx = groups.findIndex((item) =>
          item.id ? item.id === v.id : item.key === v.key,
        );
        groups.splice(selIdx, 1, v);
        setGroups([...groups]);
      }
    } else {
      newError = {
        ...list[i].error,
        ...checkValidation(prop, v),
      };
      if (prop === 'serial') {
        newValue = v.toLowerCase();
      }
      if (prop === 'alias') {
        newValue = v.slice(0, 15);
      }

      newList.splice(i, 1, {
        ...newList[i],
        [prop]: newValue,
        error: newError,
      });
      setList(newList);
    }
  };

  const updateButtons = [
    { label: '취소', onClick: onCancel },
    {
      label: '선택 수정',
      onClick: () => onUpdate({ list, groups }),
    },
  ];

  useUpdateEffect(() => {
    if (!open) {
      setList([]);
      setGroups([]);
    }
  }, [open]);

  return (
    <NewModal open={open} buttons={updateButtons} onClose={onCancel}>
      <Grid container spacing={1}>
        {list &&
          list.map((item, i) => (
            <Grid item xs={list.length === 1 ? 12 : 6} key={item.id}>
              <RobotRegisterCard
                {...item}
                groups={groups}
                name={`update_reg_card_${i}`}
                onChange={(e) => onItemChange(e, i)}
                edit
              />
            </Grid>
          ))}
      </Grid>
    </NewModal>
  );
};

export default RobotUpdateModal;
